import { InjectionToken } from '@angular/core';

/** Timings for the idle-session logout (VAPT #8: auto-logout after 15 minutes idle). */
export interface IdleTimeoutConfig {
  /** Inactivity, in ms, after which the session is ended. */
  readonly timeoutMs: number;
  /** How long before {@link timeoutMs} the warning dialog opens. */
  readonly warningMs: number;
  /** Minimum gap between cross-tab `activity` broadcasts. */
  readonly broadcastThrottleMs: number;
}

/** Kept as a token (not `environment*.ts`): a key missing from one deploy would silently disable logout. */
export const IDLE_TIMEOUT_CONFIG = new InjectionToken<IdleTimeoutConfig>('IDLE_TIMEOUT_CONFIG', {
  providedIn: 'root',
  factory: () => ({
    timeoutMs: 15 * 60_000,
    warningMs: 2 * 60_000,
    broadcastThrottleMs: 30_000,
  }),
});

/** Sign-in routes on which no idle timer runs — nobody is authenticated there yet. */
export const IDLE_EXCLUDED_PATHS: readonly string[] = [
  '/auth-redirect',
  '/token-login',
  '/emailVerification',
  '/login',
  '/securityQuestions',
];
